import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "address-editor--container" }
const _hoisted_2 = { class: "address-editor__head" }
const _hoisted_3 = { class: "address-editor__actions" }
const _hoisted_4 = {
  key: 1,
  class: "address-editor__edit-actions"
}
const _hoisted_5 = {
  key: 0,
  class: "address-editor__editing-fields"
}
const _hoisted_6 = { class: "static-value__group" }
const _hoisted_7 = { class: "static-value__group" }
const _hoisted_8 = { class: "static-value__group" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  class: "address-editor__editing-fields"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_form_select = _resolveComponent("form-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _cache[12] || (_cache[12] = _createElementVNode("h6", null, "Address details", -1))
      ], true),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isEditing)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              class: "address-editor__toggle-edit",
              flat: "",
              rounded: "",
              dense: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.edit(true)))
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("Edit")
              ])),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_q_btn, {
                class: "address-editor__toggle-edit",
                color: "primary",
                rounded: "",
                dense: "",
                onClick: _ctx.save
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode("Save")
                ])),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_q_btn, {
                class: "address-editor__toggle-edit",
                flat: "",
                rounded: "",
                dense: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.edit(false)))
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1
              })
            ]))
      ])
    ]),
    (!_ctx.isEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("dl", _hoisted_6, [
            _createElementVNode("dt", {
              class: _normalizeClass(["static-value__title", {error: !_ctx.validation_state['street']}])
            }, "Street", 2),
            _createElementVNode("dd", {
              class: _normalizeClass(["static-value__value", {error: !_ctx.validation_state['street']}])
            }, _toDisplayString(_ctx.postalAddress._street || ''), 3),
            _createElementVNode("dt", {
              class: _normalizeClass(["static-value__title", {error: !_ctx.validation_state['street_number']}])
            }, "Street Number", 2),
            _createElementVNode("dd", {
              class: _normalizeClass(["static-value__value", {error: !_ctx.validation_state['street_number']}])
            }, _toDisplayString(_ctx.postalAddress._street_number || ''), 3),
            _createElementVNode("dt", {
              class: _normalizeClass(["static-value__title", {subdue: !_ctx.postalAddress._addition, warn: !_ctx.validation_state['addition']}])
            }, "Addition", 2),
            _createElementVNode("dd", {
              class: _normalizeClass(["static-value__value", {warn: !_ctx.validation_state['addition']}])
            }, _toDisplayString(_ctx.postalAddress._addition || ''), 3)
          ]),
          _createElementVNode("dl", _hoisted_7, [
            _createElementVNode("dt", {
              class: _normalizeClass(["static-value__title", {error: !_ctx.validation_state['city']}])
            }, "City", 2),
            _createElementVNode("dd", {
              class: _normalizeClass(["static-value__value", {error: !_ctx.validation_state['city']}])
            }, _toDisplayString(_ctx.postalAddress._city || ''), 3),
            _createElementVNode("dt", {
              class: _normalizeClass(["static-value__title", { subdue: !_ctx.postalAddress.state }])
            }, "State/Province", 2),
            _createElementVNode("dd", {
              class: _normalizeClass(["static-value__value", {}])
            }, _toDisplayString(_ctx.postalAddress._state || ''), 1),
            _createElementVNode("dt", {
              class: _normalizeClass(["static-value__title", {error: !_ctx.validation_state['zipcode']}])
            }, "Zipcode", 2),
            _createElementVNode("dd", {
              class: _normalizeClass(["static-value__value", {error: !_ctx.validation_state['zipcode']}])
            }, _toDisplayString(_ctx.postalAddress._zipcode || ''), 3),
            _createElementVNode("dt", {
              class: _normalizeClass(["static-value__title", {error: !_ctx.validation_state['country_iso']}])
            }, "Country", 2),
            _createElementVNode("dd", {
              class: _normalizeClass(["static-value__value", {error: !_ctx.validation_state['country_iso']}])
            }, _toDisplayString(_ctx.postalAddress._country || _ctx.postalAddress._country_iso || ''), 3)
          ]),
          _createElementVNode("dl", _hoisted_8, [
            _createElementVNode("dt", {
              class: _normalizeClass(["static-value__title", {subdue: !_ctx.postalAddress.email, warn: !_ctx.validation_state['email']}])
            }, "Email", 2),
            _createElementVNode("dd", {
              class: _normalizeClass(["static-value__value", {warn: !_ctx.validation_state['email']}])
            }, [
              _createElementVNode("a", {
                href: `mailto:${_ctx.postalAddress.email}`
              }, _toDisplayString(_ctx.postalAddress.email || ''), 9, _hoisted_9)
            ], 2),
            _createElementVNode("dt", {
              class: _normalizeClass(["static-value__title", {subdue: !_ctx.postalAddress.phone, warn: !_ctx.validation_state['phone']}])
            }, "Phone", 2),
            _createElementVNode("dd", {
              class: _normalizeClass(["static-value__value", {warn: !_ctx.validation_state['phone']}])
            }, [
              _createElementVNode("a", {
                href: `callto:${_ctx.postalAddress.phone}`
              }, _toDisplayString(_ctx.postalAddress.phone || ''), 9, _hoisted_10)
            ], 2),
            _createElementVNode("dt", {
              class: _normalizeClass(["static-value__title", {subdue: !_ctx.postalAddress.document_id }])
            }, "Document ID", 2),
            _createElementVNode("dd", {
              class: _normalizeClass(["static-value__value", {}])
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.postalAddress.document_id || ''), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass(["address-editor--field address--street has-tooltip", {error: !_ctx.validation_state['street']}]),
            "data-tooltip": "Street Name"
          }, [
            _createVNode(_component_form_input, {
              class: "compact",
              modelValue: _ctx.postalAddress._street,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.postalAddress._street) = $event)),
              onKeydown: _withKeys(_ctx.save, ["enter"]),
              validator: v => _ctx.validation_state['street'] ? true : 'ⓧ',
              style: _normalizeStyle({minWidth: `${Math.max(24, (_ctx.postalAddress.street?.length || 1) + 2)}ch`}),
              placeholder: "Street Name"
            }, null, 8, ["modelValue", "onKeydown", "validator", "style"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["address-editor--field address--street-number has-tooltip-number", {error: !_ctx.validation_state['street_number']}]),
            "data-tooltip": "Street Number"
          }, [
            _createVNode(_component_form_input, {
              class: "compact",
              modelValue: _ctx.postalAddress._street_number,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.postalAddress._street_number) = $event)),
              onKeydown: _withKeys(_ctx.save, ["enter"]),
              validator: v => !_ctx.validation_state['street_number'] ? true : 'ⓧ',
              style: _normalizeStyle({minWidth: `${Math.max(4, (_ctx.postalAddress.street_number?.length || 1) + 2)}ch`}),
              placeholder: "0"
            }, null, 8, ["modelValue", "onKeydown", "validator", "style"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["address-editor--field address--addition has-tooltip", {error: !_ctx.validation_state['addition']}]),
            "data-tooltip": "Addition"
          }, [
            _createVNode(_component_form_input, {
              class: "compact",
              modelValue: _ctx.postalAddress._addition,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.postalAddress._addition) = $event)),
              onKeydown: _withKeys(_ctx.save, ["enter"]),
              style: _normalizeStyle({minWidth: `${Math.max(4, (_ctx.postalAddress.addition?.length || 1) + 2)}ch`}),
              placeholder: "A"
            }, null, 8, ["modelValue", "onKeydown", "style"])
          ], 2),
          _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["address-editor--field address--city has-tooltip", {error: !_ctx.validation_state['city']}]),
            "data-tooltip": "City"
          }, [
            _createVNode(_component_form_input, {
              class: "compact",
              modelValue: _ctx.postalAddress._city,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.postalAddress._city) = $event)),
              onKeydown: _withKeys(_ctx.save, ["enter"]),
              validator: v => !_ctx.validation_state['city'] ? true : 'ⓧ',
              style: _normalizeStyle({minWidth: `${Math.max(24, (_ctx.postalAddress.city?.length || 1) + 2)}ch`}),
              placeholder: "City"
            }, null, 8, ["modelValue", "onKeydown", "validator", "style"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["address-editor--field address--state has-tooltip", {}]),
            "data-tooltip": "State (-code)"
          }, [
            _createVNode(_component_form_input, {
              class: "compact",
              modelValue: _ctx.postalAddress._state,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.postalAddress._state) = $event)),
              onKeydown: _withKeys(_ctx.save, ["enter"]),
              style: _normalizeStyle({minWidth: `${Math.max(24, (_ctx.postalAddress.state?.length || 1) + 2)}ch`}),
              placeholder: "state"
            }, null, 8, ["modelValue", "onKeydown", "style"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["address-editor--field address--zipcode has-tooltip", {error: !_ctx.validation_state['zipcode']}]),
            "data-tooltip": "Zipcode"
          }, [
            _createVNode(_component_form_input, {
              class: "compact",
              modelValue: _ctx.postalAddress._zipcode,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.postalAddress._zipcode) = $event)),
              onKeydown: _withKeys(_ctx.save, ["enter"]),
              validator: v => !_ctx.validation_state['zipcode'] ? true : 'ⓧ',
              style: _normalizeStyle({minWidth: `${Math.max(12, (_ctx.postalAddress.zipcode?.length || 1) + 2)}ch`}),
              placeholder: "0000"
            }, null, 8, ["modelValue", "onKeydown", "validator", "style"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["address-editor--field address--country has-tooltip", {error: !_ctx.CountryNames.includes(_ctx.postalAddress.country)}]),
            "data-tooltip": "Country"
          }, [
            _createVNode(_component_form_select, {
              class: "compact",
              type: "select",
              style: {minWidth: '285px', marginTop: '4px'},
              "model-value": _ctx.postalAddress.country,
              options: _ctx.CountryNames,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = value => _ctx.handlers.country(value)),
              placeholder: "Country"
            }, null, 8, ["model-value", "options"])
          ], 2),
          _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["address-editor--field address--email has-tooltip", {error: !_ctx.validation_state['email']}]),
            "data-tooltip": "Email"
          }, [
            _createVNode(_component_form_input, {
              class: "compact",
              modelValue: _ctx.postalAddress._email,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.postalAddress._email) = $event)),
              onKeydown: _withKeys(_ctx.save, ["enter"]),
              style: _normalizeStyle({minWidth: `${Math.max(27, (_ctx.postalAddress.email?.length || 1) + 2)}ch`}),
              placeholder: "email"
            }, null, 8, ["modelValue", "onKeydown", "style"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["address-editor--field address--phone has-tooltip", {error: !_ctx.validation_state['phone']}]),
            "data-tooltip": "Phone Number"
          }, [
            _createVNode(_component_form_input, {
              class: "compact",
              modelValue: _ctx.postalAddress._phone,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.postalAddress._phone) = $event)),
              onKeydown: _withKeys(_ctx.save, ["enter"]),
              style: _normalizeStyle({minWidth: `${Math.max(12, (_ctx.postalAddress.phone?.length || 1) + 2)}ch`}),
              placeholder: "0"
            }, null, 8, ["modelValue", "onKeydown", "style"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["address-editor--field address--document_id has-tooltip", {}]),
            "data-tooltip": "Document ID"
          }, [
            _createVNode(_component_form_input, {
              class: "compact",
              modelValue: _ctx.postalAddress._document_id,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.postalAddress._document_id) = $event)),
              onKeydown: _withKeys(_ctx.save, ["enter"]),
              style: _normalizeStyle({minWidth: `${Math.max(12, (_ctx.postalAddress.document_id?.length || 1) + 2)}ch`}),
              placeholder: "-"
            }, null, 8, ["modelValue", "onKeydown", "style"])
          ])
        ]))
  ]))
}